export class Track {
  constructor(
    public id: string,
    public name: string,
    public url : string,
    public image: string,
    public duration_ms: number,
    public is_paid: boolean,
    public is_bonus: boolean,
    public bonus_attempts: number,
    public description: string
  ) {}
}

export class PlaylistTrack {
  constructor(
    public id: string,
    public name: string,
    public url : string,
    public image: string,
    public duration_ms: number,
    public position : number
  ) {}
}

export class TrackPosition {
  constructor(
    public playlist_id: string,
    public track_id: string,
    public position : number
  ) {}
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/track.ts